(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(7653);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3789);
/* harmony import */ var _hooks_usePermalink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8524);
/* harmony import */ var _utils_categories__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(731);
/* harmony import */ var _utils_series__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2475);








const SEP = " • ";
const MAX_TITLE_LEN = 50;
const robots = `index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1`;
const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Person",
            "@id": "https://typeofweb.com/#michal-miszczyszyn",
            name: "Michał Miszczyszyn",
            url: "https://typeofweb.com/",
            sameAs: [
                "https://pierwszedemo.com",
                "https://www.facebook.com/typeofweb",
                "https://www.instagram.com/typeofweb/",
                "https://linkedin.com/in/mmiszczyszyn",
                "https://www.youtube.com/typeofweb",
                "https://x.com/typeofweb"
            ]
        },
        {
            "@type": "Organization",
            "@id": "https://typeofweb.com/#organization",
            name: "Type of Web",
            url: "https://typeofweb.com/",
            sameAs: [
                "https://pierwszedemo.com",
                "https://www.facebook.com/typeofweb",
                "https://www.instagram.com/typeofweb/",
                "https://linkedin.com/in/mmiszczyszyn",
                "https://www.youtube.com/typeofweb",
                "https://x.com/typeofweb"
            ],
            logo: {
                "@type": "ImageObject",
                "@id": "https://typeofweb.com/#logo",
                inLanguage: "pl-PL",
                url: _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultCover.img.src */ .Iw.img.src,
                width: _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultCover.img.width */ .Iw.img.width,
                height: _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultCover.img.height */ .Iw.img.height,
                caption: "Type of Web"
            },
            image: {
                "@id": "https://typeofweb.com/#logo"
            }
        },
        {
            "@type": "WebSite",
            "@id": "https://typeofweb.com/#website",
            url: "https://typeofweb.com/",
            name: "Type of Web",
            description: "Blog o programowaniu. Dla front-end i back-end developer\xf3w. Trochę o urokach pracy zdalnej, ale przede wszystkim o: JavaScript, React, Vue, Angular, node.js, TypeScript, HapiJS…",
            publisher: {
                "@id": "https://typeofweb.com/#organization"
            },
            // potentialAction: [
            //   {
            //     '@type': 'SearchAction',
            //     target: 'https://typeofweb.com/?s={search_term_string}',
            //     'query-input': 'required name=search_term_string',
            //   },
            // ],
            inLanguage: "pl-PL"
        },
        {
            "@type": "CollectionPage",
            "@id": "https://typeofweb.com/#webpage",
            url: "https://typeofweb.com/",
            name: "Type of Web &bull; Blog o programowaniu. Dla front-end i back-end developer\xf3w. Trochę o urokach pracy zdalnej, ale przede wszystkim o: JavaScript, React, Vue, Angular, node.js, TypeScript, HapiJS…",
            isPartOf: {
                "@id": "https://typeofweb.com/#website"
            },
            about: {
                "@id": "https://typeofweb.com/#organization"
            },
            description: "Blog o programowaniu. Dla front-end i back-end developer\xf3w. Trochę o urokach pracy zdalnej, ale przede wszystkim o: JavaScript, React, Vue, Angular, node.js, TypeScript, HapiJS…",
            inLanguage: "pl-PL"
        }
    ]
};
const Seo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.memo)((param)=>{
    let { title ="" , description =_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultDescription */ .H6 , cover =_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultCover */ .Iw , author , series  } = param;
    const { query: _query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const permalink = (0,_hooks_usePermalink__WEBPACK_IMPORTED_MODULE_5__/* .usePermalink */ .z)();
    const page = (0,_hooks_usePermalink__WEBPACK_IMPORTED_MODULE_5__/* .usePage */ .q)();
    const pageTitle = page ? `Strona ${page}` : ``;
    const next = getNext(permalink, series, page);
    const prev = getPrev(permalink, series, page);
    const type = permalink ? "article" : "website";
    const isCategory = permalink ? (0,_utils_categories__WEBPACK_IMPORTED_MODULE_6__/* .permalinkIsCategory */ .Ws)(permalink) : false;
    const relevantTitle = isCategory ? `Kategoria ${permalink}` : title;
    let fullTitle = (relevantTitle ? [
        relevantTitle,
        pageTitle,
        _constants__WEBPACK_IMPORTED_MODULE_4__/* .siteName */ .aD
    ] : [
        _constants__WEBPACK_IMPORTED_MODULE_4__/* .siteName */ .aD,
        pageTitle
    ]).filter((x)=>!!x && !!x.trim()).map((x)=>x.replace(/%%(title|page|sep|sitename)%%/gi, "").trim()).join(SEP).trim();
    if (fullTitle.length < MAX_TITLE_LEN) {
        fullTitle += ` ${SEP} ${_constants__WEBPACK_IMPORTED_MODULE_4__/* .shortDescription */ .Z8}`;
    }
    const canonical = (page === 1 ? `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}${asPath}`.replace(/\/strona\/1$/, "/") : `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}${asPath}`).trim().replace(/\/$/, "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: fullTitle
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description.slice(0, 177)
            }, "description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: robots
            }, "robots"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: robots
            }, "googlebot"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "bingbot",
                content: robots
            }, "bingbot"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "profile",
                href: "https://gmpg.org/xfn/11"
            }, "profile"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }, "canonical"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "index",
                title: "Strona gł\xf3wna",
                href: `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/`
            }),
            next && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: next
            }, "next"),
            prev && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prev
            }, "prev"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "pl_PL"
            }, "og:locale"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }, "og:type"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: fullTitle
            }, "og:title"),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonical
            }, "og:url"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: _constants__WEBPACK_IMPORTED_MODULE_4__/* .siteName */ .aD
            }, "og:site_name"),
            type === "article" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: "https://www.facebook.com/typeofweb"
            }, "article:publisher"),
            type === "article" && author && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:author",
                content: author
            }, "article:author"),
            cover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: cover.img.src
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: cover.img.width.toString()
                    }, "og:image:width"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: cover.img.height.toString()
                    }, "og:image:height")
                ]
            }),
            type === "article" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                type: "application/json+oembed",
                href: `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/api/oembed?format=json&url=${encodeURIComponent(canonical)}`,
                title: fullTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "fb:app_id",
                content: "1709793622637583"
            }, "fb:app_id"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }, "twitter:card"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@typeofweb"
            }, "twitter:site"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png?v=2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/favicon-32x32.png?v=2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon-16x16.png?v=2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest?v=2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/safari-pinned-tab.svg?v=2",
                color: "#5cb784"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                href: "/favicon.ico?v=2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#5cb784"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: "#5cb784"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonLd)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                type: "application/rss+xml",
                title: "Type of Web \xbb Kanał z wpisami",
                href: `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/feed.xml`
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                type: "application/json",
                title: "Type of Web \xbb Kanał z wpisami",
                href: `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/feed.json`
            })
        ]
    });
});
Seo.displayName = "Seo";
function getNext(permalink, series, page) {
    if (permalink && series) {
        const nextSeries = (0,_utils_series__WEBPACK_IMPORTED_MODULE_7__/* .getNextSeriesLink */ .L3)(permalink, series);
        if (nextSeries) {
            return `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/${nextSeries.permalink}`;
        }
    }
    if (page) {
        return `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/strona/${page + 1}/`;
    }
    return null;
}
function getPrev(permalink, series, page) {
    if (permalink && series) {
        const prevSeries = (0,_utils_series__WEBPACK_IMPORTED_MODULE_7__/* .getPrevSeriesLink */ .PE)(permalink, series);
        if (prevSeries) {
            return `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/${prevSeries.permalink}`;
        }
    }
    if (page && page > 1) {
        return `${_constants__WEBPACK_IMPORTED_MODULE_4__/* .host */ .ho}/strona/${page - 1}/`;
    }
    return null;
}


/***/ }),

/***/ 3789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H6": function() { return /* binding */ defaultDescription; },
/* harmony export */   "Iw": function() { return /* binding */ defaultCover; },
/* harmony export */   "Z8": function() { return /* binding */ shortDescription; },
/* harmony export */   "aD": function() { return /* binding */ siteName; },
/* harmony export */   "cF": function() { return /* binding */ DELIMITER; },
/* harmony export */   "hW": function() { return /* binding */ origin; },
/* harmony export */   "ho": function() { return /* binding */ host; }
/* harmony export */ });
/* unused harmony exports protocol, pageSize, videoPageSize */
const origin = "pl.typeofweb.com" || 0 || 0;
const protocol =  true ? "https" : 0;
const host = `${protocol}://${origin}`;
const pageSize = 10;
const videoPageSize = 3;
const siteName = `Type of Web`;
const shortDescription = `Blog o programowaniu`;
const defaultDescription = `Blog o programowaniu. Dla front-end i back-end developerów. Trochę o urokach pracy zdalnej, ale przede wszystkim o: JavaScript, React, Vue, Angular, node.js, TypeScript, HapiJS…`;
const defaultCover = {
    img: {
        width: 1200,
        height: 628,
        src: `${host}/typeofweb-facebook-image-sharer.png`
    }
};
const DELIMITER = " │ ";


/***/ }),

/***/ 536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ RunningHeaderProvider; },
  "i": function() { return /* binding */ useRunningHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./hooks/useIntersectionObserver.tsx

const useIntersectionObserver = (options)=>{
    // eslint-disable-next-line -- mutable map needed here
    const unobserve = (0,react.useRef)(new Map());
    const [entry, setEntry] = (0,react.useState)(null);
    const observeElement = (0,react.useCallback)((el)=>{
        if (!el) {
            return;
        }
        if (unobserve.current.has(el)) {
            unobserve.current.get(el)?.();
        }
        unobserve.current.set(el, observe(el, setEntry, options));
    }, [
        options
    ]);
    const cleanup = (0,react.useCallback)(()=>{
        unobserve.current.forEach((callback)=>callback());
        unobserve.current.clear();
    }, []);
    (0,react.useEffect)(()=>{
        const map = unobserve.current;
        return ()=>{
            map.forEach((callback)=>callback());
            map.clear();
        };
    }, []);
    if ( false || typeof IntersectionObserver === "undefined") {
        return {
            observeElement: ()=>{},
            entry: null,
            cleanup: ()=>{}
        };
    }
    return {
        observeElement,
        entry,
        cleanup
    };
};
const observe = (()=>{
    const observers = new Map();
    const createObserver = (options)=>{
        const key = JSON.stringify(options);
        if (observers.has(key)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- has
            return observers.get(key);
        }
        const elementToCallback = new Map();
        const intersectionObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const callback = elementToCallback.get(entry.target);
                if (callback) {
                    callback(entry);
                }
            });
        }, options);
        const observer = {
            key,
            elementToCallback,
            intersectionObserver
        };
        observers.set(key, observer);
        return observer;
    };
    return (el, callback, options)=>{
        const { key , elementToCallback , intersectionObserver  } = createObserver(options);
        elementToCallback.set(el, callback);
        intersectionObserver.observe(el);
        const unobserve = ()=>{
            intersectionObserver.unobserve(el);
            elementToCallback.delete(el);
            if (elementToCallback.size === 0) {
                intersectionObserver.disconnect();
                observers.delete(key);
            }
        };
        return unobserve;
    };
})();

;// CONCATENATED MODULE: ./hooks/runningHeader.tsx



const RunningHeaderContext = /*#__PURE__*/ (0,react.createContext)(null);
RunningHeaderContext.displayName = "RunningHeaderContext";
const options = {
    threshold: [
        1
    ]
};
const RunningHeaderProvider = (param)=>{
    let { children  } = param;
    const [text, setText] = (0,react.useState)("");
    const [progress, setProgress] = (0,react.useState)(0);
    const containerElRef = (0,react.useRef)();
    // eslint-disable-next-line functional/prefer-readonly-type -- need mutable
    const currentlyVisibleHeadersRef = (0,react.useRef)(new Set());
    const { observeElement: observeHeader , entry: headerEntry , cleanup: headerCleanup  } = useIntersectionObserver(options);
    (0,react.useEffect)(()=>{
        if (!headerEntry) {
            return;
        }
        if (headerEntry.isIntersecting) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- HTMLElement
            currentlyVisibleHeadersRef.current.add(headerEntry.target);
        } else {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- HTMLElement
            currentlyVisibleHeadersRef.current.delete(headerEntry.target);
        }
        const highestHeader = Array.from(currentlyVisibleHeadersRef.current).reduce((acc, node)=>{
            if (!acc) {
                return node;
            }
            // only replace if the new header is "lower"
            if (acc.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_PRECEDING) {
                return node;
            }
            return acc;
        }, null);
        if (highestHeader) {
            setText(highestHeader.innerText.split("\n")[0]?.replace(/\s+/g, " ") ?? "");
        }
    }, [
        headerEntry
    ]);
    const progressRafRef = (0,react.useRef)();
    const updateProgress = (0,react.useCallback)(()=>{
        if (progressRafRef.current) {
            window.cancelAnimationFrame(progressRafRef.current);
        }
        progressRafRef.current = window.requestAnimationFrame(()=>{
            if (!containerElRef.current) {
                setProgress(0);
                return;
            }
            const rect = containerElRef.current.getBoundingClientRect();
            const p = Math.min(1, Math.max(0, -rect.y / (rect.height - window.innerHeight)));
            setProgress(p);
        });
    }, []);
    const setRunningHeader = (0,react.useCallback)((el)=>{
        containerElRef.current = el;
        if (!el) {
            setText("");
            headerCleanup();
            if (window) {
                window.removeEventListener("scroll", updateProgress);
            }
            return;
        }
        if (window) {
            window.addEventListener("scroll", updateProgress, {
                passive: true
            });
            el.querySelectorAll("h1,h2,h3").forEach(observeHeader);
        }
    }, [
        headerCleanup,
        observeHeader,
        updateProgress
    ]);
    const value = (0,react.useMemo)(()=>{
        return {
            text,
            setRunningHeader,
            progress
        };
    }, [
        setRunningHeader,
        text,
        progress
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningHeaderContext.Provider, {
        value: value,
        children: children
    });
};
const useRunningHeader = ()=>{
    const ctx = (0,react.useContext)(RunningHeaderContext);
    if (!ctx) {
        throw new Error("Missing RunningHeaderProvider!");
    }
    return ctx;
};


/***/ }),

/***/ 7052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useBodyFix; }
/* harmony export */ });
/* eslint-disable functional/no-this-expression -- it's a class */ /* eslint-disable functional/prefer-readonly-type -- it's a class */ const useBodyFix = ()=>{
    return fixBodyService;
};
class FixBodyService {
    fixBody() {
        if (false) {}
        if (window.matchMedia("(min-width: 1024px)").matches) {
            return;
        }
        this.windowOffsetY = window.pageYOffset;
        document.body.classList.add("not-scrollable");
        document.body.style.top = `-${this.windowOffsetY}px`;
        document.body.style.paddingRight = `${this.scrollbarWidth}px`;
        // document.body.style.marginLeft = `-${this.scrollbarWidth / 2}px`;
        const menu = document.querySelector("#main-menu-button");
        if (menu) {
            menu.style.marginRight = `${this.scrollbarWidth}px`;
        }
    }
    unfixBody() {
        if (false) {}
        if (window.matchMedia("(min-width: 1024px)").matches) {
            return;
        }
        document.body.classList.remove("not-scrollable");
        document.body.style.top = "";
        document.body.style.paddingRight = "";
        // document.body.style.marginLeft = '';
        const menu = document.querySelector("#main-menu-button");
        if (menu) {
            menu.style.marginRight = "";
        }
        document.documentElement.style.scrollBehavior = "auto";
        requestAnimationFrame(()=>{
            window.scrollTo(0, this.windowOffsetY);
            document.documentElement.style.scrollBehavior = "";
        });
    }
    setScrollbarWidth() {
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        // outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);
        requestAnimationFrame(()=>{
            const widthNoScroll = outer.offsetWidth;
            // force scrollbars
            outer.style.overflow = "scroll";
            // add innerdiv
            const inner = document.createElement("div");
            inner.style.width = "100%";
            outer.appendChild(inner);
            const widthWithScroll = inner.offsetWidth;
            // remove divs
            outer.parentNode?.removeChild(outer);
            this.scrollbarWidth = widthNoScroll - widthWithScroll;
        });
    }
    constructor(){
        this.windowOffsetY = 0;
        this.scrollbarWidth = 0;
        if (false) {}
        requestAnimationFrame(()=>this.setScrollbarWidth());
    }
}
const fixBodyService = new FixBodyService();


/***/ }),

/***/ 8524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ usePage; },
/* harmony export */   "z": function() { return /* binding */ usePermalink; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

const usePermalink = ()=>{
    const r = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- it's true
    const query = r.query;
    return query.permalink;
};
const usePage = ()=>{
    const r = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- it's true
    const query = r.query;
    return query.page ? Number(query.page) : undefined;
};


/***/ }),

/***/ 8654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useUIState; },
/* harmony export */   "g": function() { return /* binding */ UIStateProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _useBodyFix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7052);



const UIStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
UIStateContext.displayName = "UIStateContext";
const UIStateProvider = (param)=>{
    let { children  } = param;
    const [uiState, setUIState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        isMenuOpen: false
    });
    const fixBodyService = (0,_useBodyFix__WEBPACK_IMPORTED_MODULE_2__/* .useBodyFix */ .s)();
    const value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return {
            setUIState,
            uiState
        };
    }, [
        setUIState,
        uiState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (uiState.isMenuOpen) {
            fixBodyService.fixBody();
        } else {
            fixBodyService.unfixBody();
        }
    }, [
        fixBodyService,
        uiState.isMenuOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UIStateContext.Provider, {
        value: value,
        children: children
    });
};
const useUIState = ()=>{
    const ctx = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(UIStateContext);
    if (!ctx) {
        throw new Error("Missing UIStateProvider!");
    }
    return ctx;
};


/***/ }),

/***/ 7653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@vercel/analytics/dist/react/index.js
/* provided dependency */ var process = __webpack_require__(4155);
// src/react.tsx


// src/queue.ts
var initQueue = () => {
  if (window.va)
    return;
  window.va = function a(...params) {
    (window.vaq = window.vaq || []).push(params);
  };
};

// src/utils.ts
function isBrowser() {
  return typeof window !== "undefined";
}
function isDevelopment() {
  if (typeof process === "undefined")
    return false;
  return  false || "production" === "test";
}

// src/generic.ts
var inject = ({ beforeSend, debug } = { debug: isDevelopment() }) => {
  var _a;
  if (!isBrowser())
    return;
  initQueue();
  if (beforeSend) {
    (_a = window.va) == null ? void 0 : _a.call(window, "beforeSend", beforeSend);
  }
  const src = isDevelopment() ? "https://cdn.vercel-insights.com/v1/script.debug.js" : "/_vercel/insights/script.js";
  if (document.head.querySelector(`script[src*="${src}"]`))
    return;
  const script = document.createElement("script");
  script.src = src;
  script.defer = true;
  if (isDevelopment() && debug === false) {
    script.setAttribute("data-debug", "false");
  }
  document.head.appendChild(script);
};

// src/react.tsx
function Analytics({
  beforeSend,
  debug = isDevelopment()
}) {
  (0,react.useEffect)(() => {
    inject({ beforeSend, debug });
  }, [beforeSend, debug]);
  return null;
}

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/Seo.tsx
var Seo = __webpack_require__(2448);
// EXTERNAL MODULE: ./hooks/runningHeader.tsx + 1 modules
var runningHeader = __webpack_require__(536);
// EXTERNAL MODULE: ./hooks/useUiState.tsx
var useUiState = __webpack_require__(8654);
// EXTERNAL MODULE: ./styles.css
var styles = __webpack_require__(7817);
// EXTERNAL MODULE: ./fonts.css
var fonts = __webpack_require__(9733);
// EXTERNAL MODULE: ./prism.css
var prism = __webpack_require__(9477);
// EXTERNAL MODULE: ./node_modules/katex/dist/katex.min.css
var katex_min = __webpack_require__(1098);
;// CONCATENATED MODULE: ./pages/_app.tsx













function ScriptOnce(props) {
    const [render, setRender] = (0,react.useState)(true);
    (0,react.useEffect)(()=>setRender(false), []);
    return render ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        ...props
    }) : null;
}
function ScriptAfterInteraction(param) {
    let { children , id , ...props } = param;
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", listener, {
            passive: true,
            once: true
        });
        if (sessionStorage["s" + id]) {
            // hopefully the script is cached at this point
            listener();
        }
        return ()=>{
            window.removeEventListener("scroll", listener);
        };
        function listener() {
            sessionStorage["s" + id] = true;
            window.removeEventListener("scroll", listener);
            (window.requestIdleCallback || window.requestAnimationFrame)(()=>{
                const script = Object.entries(props).reduce((script, param)=>{
                    let [key, value] = param;
                    // @ts-ignore
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-member-access -- we know that value is a keyof script
                    script[key] = value;
                    return script;
                }, document.createElement("script"));
                if (children) {
                    script.textContent = children;
                }
                document.body.appendChild(script);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ignore
    }, []);
    return null;
}
const MyApp = (param)=>{
    let { Component , pageProps  } = param;
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const handleRouteChange = (url)=>{
            window.gtag("config", "UA-75923815-1", {
                page_path: url
            });
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return ()=>{
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events
    ]);
    const urlsToPreload = pageProps?.posts?.map((p)=>p?.frontmatter?.cover?.blurDataURL).filter(Boolean);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, user-scalable=yes, initial-scale=1.0, viewport-fit=cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScriptOnce, {
                strategy: "afterInteractive",
                children: `let o=()=>e.className+=" fonts-loaded",e=document.documentElement,n="00 1em Merriweather",t="00 1em Fira Sans";sessionStorage.fonts?o():Promise.all(["4"+n,"7"+n,"italic 4"+n,"italic 7"+n,"4"+t,"6"+t,"400 1em Fira Mono"].map(o=>document.fonts.load(o))).then(()=>{sessionStorage.fonts=!0,o()})`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                src: `https://www.googletagmanager.com/gtag/js?id=UA-75923815-1`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtag-init",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-75923815-1', {
              page_path: window.location.pathname
            });
          `.trim()
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "algolia-search-insights",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: `
            var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@2.0.3";

            !function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){
            (e[s].queue=e[s].queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],
            i.async=1,i.src=n,c.parentNode.insertBefore(i,c)
            }(window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");
          `.trim()
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                "data-domain": "typeofweb.com",
                "data-api": "/api/event",
                src: "/js/script.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(runningHeader/* RunningHeaderProvider */.b, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useUiState/* UIStateProvider */.g, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                        ...pageProps
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Analytics, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScriptAfterInteraction, {
                id: "fancyLinkUnderline",
                defer: true,
                async: true,
                children: `window?.CSS?.paintWorklet?.addModule("/fancyLinkUnderline.min.js")`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScriptAfterInteraction, {
                id: "contentVisibility",
                src: "/contentVisibility.min.js",
                defer: true,
                async: true
            }),
            urlsToPreload?.map((url)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: url,
                    as: "image"
                }, url))
        ]
    });
};
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ allCategories; },
/* harmony export */   "Od": function() { return /* binding */ getCategoryLink; },
/* harmony export */   "Ws": function() { return /* binding */ permalinkIsCategory; }
/* harmony export */ });
/* unused harmony exports categoryMappings, categorySlugToCategory, categoriesToMainCategory */
const categoryMappings = {
    "front-end+javascript": "javascript",
    "inicjatywy+opinie": "opinie",
    opinie: "opinie",
    "dobry-kod+front-end+javascript": "dobry-kod",
    "back-end+javascript": "javascript",
    "back-end+front-end+javascript": "javascript",
    "dobry-kod+javascript": "dobry-kod",
    "javascript+opinie": "opinie",
    wpis: "opinie",
    "dobry-kod": "dobry-kod",
    "opinie+praca-zdalna": "praca-zdalna",
    "front-end+opinie": "opinie",
    "dobry-kod+inicjatywy": "dobry-kod",
    "dobry-kod+opinie": "dobry-kod",
    javascript: "javascript",
    typescript: "typescript",
    "front-end": "javascript",
    "praca-zdalna": "praca-zdalna",
    inicjatywy: "opinie",
    "back-end+dobry-kod+front-end+javascript": "javascript",
    "back-end+opinie": "opinie",
    "back-end": "javascript",
    "back-end+dobry-kod": "dobry-kod",
    "back-end+front-end": "javascript",
    "inicjatywy+praca-zdalna": "praca-zdalna"
};
const allCategories = [
    {
        slug: "javascript",
        name: "JavaScript"
    },
    {
        slug: "typescript",
        name: "TypeScript"
    },
    {
        slug: "opinie",
        name: "Opinie"
    },
    {
        slug: "dobry-kod",
        name: "Dobry Kod"
    },
    {
        slug: "praca-zdalna",
        name: "Praca Zdalna"
    }
];
function permalinkIsCategory(permalink) {
    return allCategories.map((c)=>c.slug).includes(permalink);
}
function categorySlugToCategory(categorySlug) {
    const mainCategory = allCategories.find((c)=>c.slug === categorySlug) ?? null;
    return mainCategory;
}
function categoriesToMainCategory(categories) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ok, because we know the type
    const categoryMappingKey = categories?.map((c)=>c.slug).sort().join("+");
    const mainCategorySlug = categoryMappingKey ? categoryMappings[categoryMappingKey] : null;
    return categorySlugToCategory(mainCategorySlug);
}
const getCategoryLink = (categoryOrSlug)=>typeof categoryOrSlug === "string" ? `/${categoryOrSlug}` : `/${categoryOrSlug.slug}`;


/***/ }),

/***/ 2475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CX": function() { return /* binding */ getSeriesLink; },
/* harmony export */   "L3": function() { return /* binding */ getNextSeriesLink; },
/* harmony export */   "P3": function() { return /* binding */ permalinkIsSeries; },
/* harmony export */   "PE": function() { return /* binding */ getPrevSeriesLink; },
/* harmony export */   "fZ": function() { return /* binding */ findCurrentSeriesIndex; }
/* harmony export */ });
/* unused harmony exports allSeries, seriesSlugToSeries */
const findCurrentSeriesIndex = (currentPostPermalink, seriesPermalinks)=>{
    return seriesPermalinks.findIndex((param)=>{
        let { permalink  } = param;
        return permalink === currentPostPermalink;
    });
};
const getNextSeriesLink = (currentPostPermalink, seriesPermalinks)=>{
    if (currentPostPermalink && seriesPermalinks) {
        const currentIndex = findCurrentSeriesIndex(currentPostPermalink, seriesPermalinks.links);
        if (currentIndex < seriesPermalinks.links.length - 1) {
            return seriesPermalinks.links[currentIndex + 1];
        }
    }
};
const getPrevSeriesLink = (currentPostPermalink, seriesPermalinks)=>{
    if (currentPostPermalink && seriesPermalinks) {
        const currentIndex = findCurrentSeriesIndex(currentPostPermalink, seriesPermalinks.links);
        if (currentIndex > 1) {
            return seriesPermalinks.links[currentIndex - 1];
        }
    }
};
const allSeries = [
    {
        slug: "self-publishing",
        name: "Self Publishing"
    },
    {
        slug: "react-js",
        name: "React.js"
    },
    {
        slug: "piece-of-cake",
        name: "Piece of cake"
    },
    {
        slug: "buddy-works",
        name: "CI/CD z Buddy.works"
    },
    {
        slug: "vue-js",
        name: "Vue.js"
    },
    {
        slug: "hapijs",
        name: "HapiJS"
    },
    {
        slug: "typescript",
        name: "TypeScript"
    },
    {
        slug: "angular-2",
        name: "Angular 2"
    }
];
function seriesSlugToSeries(seriesSlug) {
    return allSeries.find((series)=>series.slug === seriesSlug) ?? null;
}
const getSeriesLink = (seriesOrSlug)=>typeof seriesOrSlug === "string" ? `/kurs/${seriesOrSlug}` : `/kurs/${seriesOrSlug.slug}`;
function permalinkIsSeries(permalink) {
    return allSeries.map((s)=>s.slug).includes(permalink);
}


/***/ }),

/***/ 1098:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9733:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9477:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7817:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(880)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ }),

/***/ 4155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);